import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { faCircleChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import { useHttpClient } from '../../shared/hooks/http-hook';
import HorizontalSlider from '../components/HorizontalSlider';
import Influencers from '../components/Influencers';
import Journal from '../components/Journal';
import TrackerHeading from '../components/TrackerHeading';

function EnergyTracker(props) {
  const { t } = useTranslation();
  const { sendRequest } = useHttpClient();
  const [isSaved, setIsSaved] = useState(false);
  const [date, setDate] = useState(false);
  const [data, setData] = useState(null);
  const [currentTracker, setCurrentTracker] = useState(null);
  const [journal, setJournal] = useState(null);

  const getData = useCallback(
    async (energyDate) => {
      if (energyDate.length > 0) {
        try {
          const response = await sendRequest(
            `${process.env.REACT_APP_BACKEND_URL}/trackers/energy/${energyDate}`
          );

          if (response && response.tracker?._id) {
            const { tracker } = response;
            setCurrentTracker({
              id: tracker._id,
              trackerDate: tracker.tracker_date.toString().slice(0, 10),
            });
            const parsedData = JSON.parse(tracker.data);
            setData(parsedData);
            setJournal({
              enhancers: tracker.enhancers,
              inhibitors: tracker.inhibitors,
              journal: tracker.journal,
            });
            setIsSaved(true);
          } else {
            setCurrentTracker({
              id: '',
              trackerDate: energyDate,
            });
            setData({
              energy_level: 5,
              bar_index: 16,
            });
            setJournal(() => ({
              enhancers: [],
              inhibitors: [],
              journal: '',
            }));
          }
        } catch (err) {}
      }
    },
    [sendRequest]
  );

  useEffect(() => {
    getData(date);
  }, [date, getData]);

  const clearTracker = () => {};

  const saveResponse = (location, stat) => {
    if (location === 'journal') {
      setJournal((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    } else {
      setData((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    }
  };

  const sendData = async () => {
    let method = 'POST';
    let url = `${process.env.REACT_APP_BACKEND_URL}/trackers/`;
    if (currentTracker.id !== '') {
      method = 'PUT';
      url = `${process.env.REACT_APP_BACKEND_URL}/trackers/${currentTracker.id}`;
    }

    try {
      const response = await sendRequest(
        url,
        method,
        JSON.stringify({
          trackerDate: date,
          type: 'energy',
          data,
          hidden: false,
          enhancers: journal.enhancers,
          inhibitors: journal.inhibitors,
          journal: journal.journal,
          platform: 'web',
        })
      );
      if (response) {
        setIsSaved(true);
        props.closeTrackers();
      }
    } catch (err) {}
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendData();
  };

  return (
    <div
      id="snm-energy"
      className="tracker-container"
      role="region"
      aria-label={`${t('T358')} ${t('tracker.region.title')}`}
    >
      <form className="tracker-form" onSubmit={handleSubmit} noValidate={false}>
        <div className="trackers-inner">
          <div className="back-to-main">
            <button
              className="back-btn"
              aria-label={t('A136')}
              title={t('A136')}
              onClick={props.handleBackToMain}
              type="button"
            >
              <FontAwesomeIcon icon={faCircleChevronLeft} />
            </button>
          </div>
          <TrackerHeading
            title="T048"
            setDate={setDate}
            isSaved={isSaved}
            clearTracker={clearTracker}
          />
          <div className="trackers-body" role="group" aria-label={t('modal.tracker.details')}>
            <fieldset className="ind-tracker no-padding">
              <legend className="title">{t('T049')}</legend>
              <HorizontalSlider
                scale1to10
                questionid="energy_level"
                data={data}
                saveResponse={saveResponse}
                required
                title={t('T049')}
              />
              <input
                type="hidden"
                name="energy_level"
                value={data?.energy_level || ''}
                required
                aria-label={t('T049')}
              />
            </fieldset>
            <fieldset className="ind-tracker no-padding">
              <legend
                className="tracker-content-heading title title-with-border"
                id="energy-influencers-title"
              >
                <h2 className="title">{t('T050')}</h2>
                <p className="optional-text">{t('T019')}</p>
              </legend>
              <Influencers
                energy
                questionid={['enhancers', 'inhibitors']}
                data={journal}
                saveResponse={saveResponse}
                greenListAriaLabel={t('trackers.influencers.energyEnhancers')}
                redListAriaLabel={t('trackers.influencers.energyInhibitors')}
                titleId="energy-influencers-title"
              />
            </fieldset>
            <div className="ind-tracker" role="group" aria-label={`${t('T358')} - ${t('T018')}`}>
              <Journal
                placeholder={t('T544')}
                questionid="journal"
                data={journal}
                saveResponse={saveResponse}
              />
            </div>
          </div>
        </div>
        <div className="buttons">
          <Button onClick={props.closeTrackers} variant="secondary" color="dark" type="button">
            {t('T015')}
          </Button>
          <Button type="submit" icon={{ faIconDefinition: faArrowRight }} iconPosition="right">
            {t('T016')}
          </Button>
        </div>
      </form>
    </div>
  );
}
export default EnergyTracker;
